export enum OrganizationMutations {
  RESET = "RESET",
  SET_ORG_INFO = "SET_ORG_INFO",
  SET_ORGANIZATIONS = "SET_ORGANIZATIONS",
}
